const styles = (theme) => ({
  root: {
    maxHeight: 400,
    overflow: 'hidden',
    backgroundColor: theme.ModalBGColor,
    padding: '17px'
  },
  radioLabel: {
    height: '12px'
  },
  label: {
    color: theme.gridTextColor,
    fontWeight: 600,
    fontSize: theme.textFontSize
  },
  radioRoot: {
    width: '20px',
    color: theme.HeaderSelectedText
  },
  textField: {
    display: 'flex'
  },
  searchBar: {
    borderBottom: `1px solid ${theme.iconColor}`,
    padding: '0px 8px'
  },
  list: {
    paddingTop: '10px'
  },
  selectAllRoot: {
    padding: 0,
  },
  listroot: {
    overflowY: 'auto',
    maxHeight: 250
  },
  inputroot: {
    color: theme.gridTextColor,
    fontSize: theme.textFontSize
  },
  noOptions: {
    padding: '18px',
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize
  },
  regionNameListItem: {
    padding: '0 0 0 8',
    maxWidth: '30%'
  },
  terminalCodeListItem: {
    padding: '0 0 0 8',
  },
  enablePadding: {
    paddingLeft: '25px'
  },
  selectAllClicked: {
    padding: 0,
    '&:hover': {
      backgroundColor: theme.ModalBGColor
    },
    '&:focus': {
      backgroundColor: theme.ModalBGColor
    }
  },
  terminalClicked: {
    padding: '0 0 8 0',
    '&:hover': {
      backgroundColor: theme.ModalBGColor
    },
    '&:focus': {
      backgroundColor: theme.ModalBGColor
    }
  },
  terminalMenu: {
    background: theme.ModalBGColor,
    borderRadius: '0px 0px 4px 4px',
    width: 288,
  },
  collapseIconStyle: {
    marginRight: '5px',
    fontSize: '22px'
  },
  listItemIcon: {
    marginRight: '0px',
    cursor: "pointer",
  },
  terminalCheckbox: {
    padding: 0,
    color: theme.palette.primary.main,
  },
  checkBoxStyle: {
    color: theme.palette.primary.main,
    padding: "0px",
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  sizeIcon: {
    fontSize: 16,
  },
});

export default styles;
